<template>
  <div class="basicinfo" style="height: 100%">
    <div class="return">
      <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
    </div>
    <div class="content">
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
          <h4 class="title">{{$t('LanguageLib.BASIC_CONFIGURATION')}}</h4>
          <div class="configbox">
            <p class="configTitle">{{$t('LanguageLib.COMPANY_NAME')}}</p>
            <el-form-item prop="ownerName">
              <el-input style="width:" v-model="ruleForm.ownerName" maxlength="50" :placeholder="$t('LanguageLib.PleaseEnter')"></el-input>
            </el-form-item>
          </div>
          <!-- <div class="configbox">
            <p class="configTitle">{{$t('LanguageLib.DEFAULT_LANGUAGE')}}</p>
            <el-select v-model="ruleForm.ownerLanguage" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div> -->
          <div class="configbox">
            <p style="margin-bottom: 10px;" class="configTitle">{{$t('LanguageLib.UPLOAD_IMAGE')}}</p>
            <div style="display:flex;flex-wrap: wrap;">
              <div class="imageBox">
                <el-upload
                  :data="formData"
                  :headers="headers()"
                  :class="{uoloadSty:showBtnlogoUrl,disUoloadSty:noneBtnlogoUrl}"
                  :action="uploadApi"
                  accept="image/*"
                  list-type="picture-card"
                  :limit="1"
                  :file-list="fileListUrl"
                  :on-preview="handlePictureCardPreview"
                  :on-success="(response, file, fileList)=>{imageUploadSuccess(response, file, fileList, 0)}"
                  :before-upload="(file) => {beforeAvatarUploadImg(file, 0)}"
                  :on-remove="(file, fileList) => {handleRemove(file, fileList, 0)}">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <p class="imageDesc">{{$t('LanguageLib.STARTUP_PAGE_DIAGRAM')}}</p>
              </div>
              <div class="imageBox">
                <el-upload
                  :data="formData"
                  :headers="headers()"
                  :class="{uoloadSty:showBtnlogoThumbUrl,disUoloadSty:noneBtnlogoThumbUrl}"
                  :action="uploadApi"
                  accept="image/*"
                  list-type="picture-card"
                  :limit="1"
                  :on-preview="handlePictureCardPreview"
                  :file-list="fileListThumbUrl"
                  :on-success="(response, file, fileList)=>{imageUploadSuccess(response, file, fileList, 1)}"
                  :before-upload="(file) => {beforeAvatarUploadImg(file, 1)}"
                  :on-remove="(file, fileList) => {handleRemove(file, fileList, 1)}">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <p class="imageDesc">{{$t('LanguageLib.ABOUT_PAGE_MAP')}}</p>
              </div>
              <div class="imageBox">
                <el-upload
                  :data="formData"
                  :headers="headers()"
                  :class="{uoloadSty:showBtnlogoImageUrl,disUoloadSty:noneBtnlogoImageUrl}"
                  :action="uploadApi"
                  accept="image/*"
                  list-type="picture-card"
                  :file-list="fileListImageUrl"
                  :limit="1"
                  :on-preview="handlePictureCardPreview"
                  :on-success="(response, file, fileList)=>{imageUploadSuccess(response, file, fileList, 2)}"
                  :before-upload="(file) => {beforeAvatarUploadImg(file, 2)}"
                  :on-remove="(file, fileList) => {handleRemove(file, fileList, 2)}">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <p class="imageDesc">{{$t('LanguageLib.COMPANY_HOMEPAGE_MAP')}}</p>
              </div>
            </div>
          </div>
          <div class="configbox">
            <p class="configTitle">{{$t('LanguageLib.WEEK_SET')}}</p>
            <el-select v-model="ruleForm.weekStartDay" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
              <el-option
                v-for="(item, index) in week"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="configbox">
            <p class="configTitle">{{$t('LanguageLib.FIRST_WEEK_OF_EACH_YEAR')}}</p>
            <el-select v-model="weekMode" :placeholder="$t('LanguageLib.PLEASE_CHOOSE')">
              <el-option
                v-for="(item, index) in oneweekset"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="configbox">
            <div>
              <el-checkbox v-model="mustSignUserAgreement">{{$t('LanguageLib.AGREEMENT_MUST_BE_SIGNED_AT_LOGIN')}}</el-checkbox>
            </div>
            <div style="margin-top:10px;padding-left: 23px;">
              <el-upload
                :data="formData"
                :disabled="!mustSignUserAgreement"
                :headers="headers()"
                class="upload-file"
                :action="uploadApi"
                :limit="1"
                :before-upload="beforeAvatarUploadWord"
                :on-success="(response, file, fileList)=>{WordUploadSuccess(response, file, fileList)}"
                :on-exceed="(file, fileList)=>{judgeLength(file, fileList)}"
                :file-list="fileList">
                <el-button :disabled="!mustSignUserAgreement" style="margin-bottom: 0px;" size="small" type="primary">{{$t('LanguageLib.CLICK_UPLOAD')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$t('LanguageLib.UPLOAD_LIMIT_WORD')}}</div>
              </el-upload>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import companyallocationApi from '../../api/companyallocation'
import baseUrl from '@/utils/base'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'companyallocation',
  props: ['currentPage', 'pageSize', 'searchText', 'sort', 'sortOrder'],
  data () {
    var checkWeekSet = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.WEEK_SET_1') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    var checkOwnerName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.COMPANY_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.COMPANY_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    var checkLang = (rule, value, callback) => {
      if (value === '' || value === undefined) {
        return callback(new Error(this.$t('LanguageLib.DEFAULT_LANGUAGE') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        callback()
      }
    }
    return {
      showBtnlogoUrl: true,
      noneBtnlogoUrl: false,
      showBtnlogoThumbUrl: true,
      noneBtnlogoThumbUrl: false,
      showBtnlogoImageUrl: true,
      noneBtnlogoImageUrl: false,
      agreementUrl: '',
      formData: { path: 'images' },
      uploadApi: baseUrl.uploadApi, // 上传地址
      options: [{
        label: this.$t('LanguageLib.SIMPLIFIED_CHINESE'),
        value: 0
      }, {
        label: this.$t('LanguageLib.TRADITIONAL_CHINESE'),
        value: 1
      }, {
        label: this.$t('LanguageLib.ENGLISH'),
        value: 2
      }, {
        label: this.$t('LanguageLib.JAPANESE'),
        value: 3
      }, {
        label: this.$t('LanguageLib.KOREAN'),
        value: 4
      }], // 基础配置数据
      week: [{
        label: this.$t('LanguageLib.SUNDAY'),
        value: 7
      }, {
        label: this.$t('LanguageLib.ON_MONDAY'),
        value: 1
      }, {
        label: this.$t('LanguageLib.ON_TUESDAY'),
        value: 2
      }, {
        label: this.$t('LanguageLib.ON_WEDNESDAY'),
        value: 3
      }, {
        label: this.$t('LanguageLib.THURSDAY'),
        value: 4
      }, {
        label: this.$t('LanguageLib.FRIDAY'),
        value: 5
      }, {
        label: this.$t('LanguageLib.ON_SATURDAY'),
        value: 6
      }], // 一周数组
      oneweekset: [{
        label: this.$t('LanguageLib.MECHANISM_CONTAINS_THE_WEEK_OF_JANUARY_1'),
        value: 1
      }, {
        label: this.$t('LanguageLib.MECHANISM_WEEK_CONTAINING_1_FIRST_THURSDAY'),
        value: 2
      }], // 第一周设置
      weekMode: '', // 第一周模式
      mustSignUserAgreement: true, // 登陆APP时是否必须签署用户协议
      cropImageDialog: false,
      logoUrl: '', // 公司启动页面图Url
      logoThumbUrl: '', // 公司关于页面图Url
      logoImageUrl: '', // 公司主页图Url
      previews: {},
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],
      fileListUrl: [],
      fileListThumbUrl: [],
      fileListImageUrl: [],
      imageHeight: '',
      imageWidth: '',
      ruleForm: {
        weekStartDay: '', // 每周第一天
        ownerName: '', // 公司名称
        ownerLanguage: '' // 默认语言
      },
      rules: {
        weekMode: [{
          validator: checkWeekSet,
          trigger: 'blur'
        }],
        ownerName: [{
          validator: checkOwnerName,
          trigger: 'blur'
        }],
        ownerLanguage: [{
          validator: checkLang,
          trigger: 'blur'
        }]
      },
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    companyallocationApi.GetBasicInfo('get', '/ownerinfo/getbasicinfo')
      .then(res => {
        NProgress.done()
        next(vm => {
          console.log(res.data)
          vm.ruleForm.ownerName = res.data.ownerName
          vm.ruleForm.ownerLanguage = res.data.ownerLanguage
          vm.ruleForm.weekStartDay = res.data.weekStartDay
          vm.weekMode = res.data.weekMode
          vm.mustSignUserAgreement = res.data.mustSignUserAgreement
          vm.logoUrl = res.data.logoUrl
          vm.logoThumbUrl = res.data.logoThumbUrl
          vm.logoImageUrl = res.data.logoImageUrl
          vm.fileList = []
          vm.fileListUrl = []
          vm.fileListThumbUrl = []
          vm.fileListImageUrl = []
          vm.agreementUrl = res.data.agreementUrl
          vm.imageHeight = res.data.imageHeight
          vm.imageWidth = res.data.imageWidth
          if (res.data.agreementUrl) {
            vm.fileList.push({
              name: res.data.agreementUrl.slice(res.data.agreementUrl.lastIndexOf('/') + 1),
              url: res.data.agreementUrl
            })
          }
          if (res.data.logoUrl) {
            vm.fileListUrl.push({
              name: res.data.logoUrl.slice(res.data.logoUrl.lastIndexOf('/') + 1),
              url: res.data.logoUrl
            })
          }
          if (res.data.logoThumbUrl) {
            vm.fileListThumbUrl.push({
              name: res.data.logoThumbUrl.slice(res.data.logoThumbUrl.lastIndexOf('/') + 1),
              url: res.data.logoThumbUrl
            })
          }
          if (res.data.logoImageUrl) {
            vm.fileListImageUrl.push({
              name: res.data.logoImageUrl.slice(res.data.logoImageUrl.lastIndexOf('/') + 1),
              url: res.data.logoImageUrl
            })
          }
          vm.noneBtnlogoUrl = (res.data.logoUrl !== '' && res.data.logoUrl !== null)
          vm.showBtnlogoUrl = (res.data.logoUrl === '' || res.data.logoUrl === null)
          vm.noneBtnlogoThumbUrl = (res.data.logoThumbUrl !== '' && res.data.logoThumbUrl !== null)
          vm.showBtnlogoThumbUrl = (res.data.logoThumbUrl === '' || res.data.logoThumbUrl === null)
          vm.noneBtnlogoImageUrl = (res.data.logoImageUrl !== '' && res.data.logoImageUrl !== null)
          vm.showBtnlogoImageUrl = (res.data.logoImageUrl === '' || res.data.logoImageUrl === null)
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  created () {
  },
  methods: {
    // 上传图片删除
    handleRemove (file, fileList, type) {
      switch (type) {
        case 0:
          this.showBtnlogoUrl = true
          this.noneBtnlogoUrl = false
          break
        case 1:
          this.showBtnlogoThumbUrl = true
          this.noneBtnlogoThumbUrl = false
          break
        case 2:
          this.showBtnlogoImageUrl = true
          this.noneBtnlogoImageUrl = false
          break
      }
    },
    // 判断文件数量
    judgeLength (file, fileList) {
      this.$message({
        message: this.$t('LanguageLib.AGREEMENT_HAVE'),
        type: 'error'
      })
    },
    // 图片上传校验
    beforeAvatarUploadImg (file, type) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension =
        testmsg === 'jpg' ||
        testmsg === 'JPG' ||
        testmsg === 'png' ||
        testmsg === 'PNG' ||
        testmsg === 'bpm' ||
        testmsg === 'jpeg' ||
        testmsg === 'JPEG' ||
        testmsg === 'webp' ||
        testmsg === 'WEBP' ||
        testmsg === 'BPM'
      if (!extension) {
        this.$message({
          message: this.$t('LanguageLib.PLEASE_SELECT_CORRECT_PICTURE_FORMAT'),
          type: 'error'
        })
        return false
      }
      switch (type) {
        case 0:
          this.showBtnlogoUrl = false
          this.noneBtnlogoUrl = true
          break
        case 1:
          this.showBtnlogoThumbUrl = false
          this.noneBtnlogoThumbUrl = true
          break
        case 2:
          this.showBtnlogoImageUrl = false
          this.noneBtnlogoImageUrl = true
          break
      }
      return extension
    },
    // word上传校验
    beforeAvatarUploadWord (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension =
        testmsg === 'doc' ||
        testmsg === 'docx' ||
        testmsg === 'DOC' ||
        testmsg === 'DOCX'
      const isLt50M = file.size / 1024 / 1024 < 10
      if (!extension) {
        this.$message({
          message: this.$t('LanguageLib.UPLOAD_LIMIT_WORD'),
          type: 'error'
        })
        return false
      }
      if (!isLt50M) {
        this.$message({
          message: this.$t('LanguageLib.UPLOAD_LIMIT_WORD'),
          type: 'error'
        })
        return false
      }
      return extension || isLt50M
    },
    // 图片上传成功
    imageUploadSuccess (response, file, fileList, type) {
      switch (type) {
        case 0:
          this.logoUrl = response[0]
          break
        case 1:
          this.logoThumbUrl = response[0]
          break
        case 2:
          this.logoImageUrl = response[0]
          var img = new Image()
          img.src = this.logoImageUrl
          img.onload = () => {
            this.imageWidth = img.width
            this.imageHeight = img.height
          }
          break
      }
    },
    // word上传成功
    WordUploadSuccess (response, file, fileList, type) {
      this.agreementUrl = response[0]
    },
    // 预览上传图片
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    headers () {
      return { token: this.$commonfun.localStorage.getitem('token'), lang: this.$commonfun.localStorage.getitem('lang') }
    },
    // 保存数据
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          var data = {
            ownerName: this.ruleForm.ownerName,
            ownerLanguage: this.ruleForm.ownerLanguage,
            logoUrl: this.logoUrl,
            logoThumbUrl: this.logoThumbUrl,
            logoImageUrl: this.logoImageUrl,
            imageHeight: this.imageHeight,
            imageWidth: this.imageWidth,
            weekStartDay: this.ruleForm.weekStartDay,
            mustSignUserAgreement: this.mustSignUserAgreement,
            agreementUrl: this.agreementUrl,
            weekMode: this.weekMode
          }
          companyallocationApi.SaveBasicInfo('post', '/ownerinfo/updatebasicinfo', data)
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SAVED_SUCCESSFULLY')
              })
              this.$commonfun.localStorage.setitem('ownerName', this.ruleForm.ownerName)
              this.loadingSave = false
            })
            .catch(err => {
              this.loadingSave = false
              this.$commonfun.console.log(err)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.basicinfo{
  ul{
    margin: 0;
    padding: 0;
  }
  li{
    list-style: none;
  }
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 25px;
    padding-top: 15px;
    .title{
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      margin-bottom: 16px;
    }
    .configbox{
      padding-left: 16px;
      margin-bottom: 24px;
      .configTitle{
        height: 16px;
        font-size: 14px;
        font-weight: 400;
        color: #4D4D4D;
        line-height: 16px;
        margin-bottom: 6px;
      }
      .el-input{
        width: 320px;
        height: 40px;
      }
      .el-upload--picture-card{
        width: 100px;
        height: 100px;
        line-height: 100px;
      }
      .el-upload-list--picture-card .el-upload-list__item{
        width: 100px;
        height: 100px;
        line-height: 100px;
      }
      .el-icon-upload-success.el-icon-check{
        top: 0px;
        position: absolute;
        right: 14px;
      }
      .el-progress-circle{
        width: 100px !important;
        height: 100px !important;
      }
      .el-progress.el-progress--circle{
        width: 100px;
      }
      .el-upload-list__item{
        width: 300px;
      }
      .imageBox{
        margin-right: 10px;
      }
      .imageDesc{
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        text-align: center;
        margin-top: 10px;
      }
      .disUoloadSty .el-upload--picture-card{
        display:none;   /* 上传按钮隐藏 */
      }
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  // 修改按钮样式
  .el-button--default{
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .el-button--default:focus, .el-button--default:hover{
    color: #3BC6B9;
    border-color: #3BC6B9;
  }
  .el-textarea__inner{
    font: 400 14px Arial;
  }
  .el-input .is-disabled{
    color: #2c3e50;
  }
  .uoloadSty{
    margin-bottom: 22px;
  }
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #606266;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}

</style>
